const getssc = data => {
  let doubleData = JSON.parse(data.num_history_json);
  return doubleData;
};

const gethpten = data => {
  let doubleData = JSON.parse(data.ball_history_json);
  let returnData = {};
  Object.keys(doubleData).map(x => {
    let key = x.slice(4);
    returnData[key] = doubleData[x];
  });
  return returnData;
};
const getchoose5 = data => {
  let doubleData = JSON.parse(data.num_history_json);
  let returnData = {};
  Object.keys(doubleData).map(x => {
    let key = Number(x);
    returnData[key] = doubleData[x];
  });
  return returnData;
};
const getpk10 = data => {
  let doubleData = JSON.parse(data.ball_history_json);
  let returnData = {};
  Object.keys(doubleData).map(x => {
    let key = x.slice(4);
    returnData[key] = doubleData[x];
  });
  return returnData;
};

export default (type, list) => {
  if (type == 'ssc') {
    return getssc(list);
  }
  if (type == 'choose5') {
    return getchoose5(list);
  }
  if (type == 'PK10' || type == 'nn') {
    return getpk10(list);
  }
  if (type == 'hpten') {
    return gethpten(list);
  }
};



// WEBPACK FOOTER //
// ./src/helpers/statistic/getDoubleDiscData.js